import React, { useState, useEffect } from 'react';

import searchIcon from '../../icons/SVG/search-solid.svg';
import hamburgerIcon from '../../icons/SVG/hamburger.svg';
import xIcon from '../../icons/SVG/X.svg';

import SasktelLogoRightSVG from '../../icons/SasktelLogoRightSVG';
import SasktelLogoLeftSVG from '../../icons/SasktelLogoLeftSVG';

import './NavBar.css';

function NavBar(props) {
  const [isScrollTop, setIsScrollTop] = useState(true);

  const onScrollTop = stateVal => {
    setIsScrollTop(stateVal);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 60) {
        onScrollTop(false);
      } else {
        onScrollTop(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={'h-45 bg-white border-light-grey w-full top-0 z-10 transition-all ' + (isScrollTop ? 'xl:h-60 border-b-1' : 'stick')}>
      <div className="py-0 pl-15 md:pl-30 lg:pl-45 mx-auto my-0 max-w-w-7xl w-full flex flex-row justify-between">
        <a href="/">
          <span className={'flex flex-row' + (isScrollTop ? ' mt-3' : ' mt-n7')}>
            <SasktelLogoLeftSVG fill="#111111" viewbox="0 0 1024 240" classes="w-75 xl:w-100 h-40 xl:h-60" />
            <SasktelLogoRightSVG fill="#0074b3" height="35" width="35" viewbox="0 0 1024 700" classes="mt-8 xl:mt-13 ml-5 w-25 xl:w-35 h-25 xl:h-35" />
          </span>
        </a>

        <ul className="flex flex-row block xl:hidden">
          {props.isSearchToggled ? (
            <li className="h-45 w-45 pt-2 mr-2 bg-almost-black">
              <a className="" onClick={props.clickSearch}>
                <img src={searchIcon} alt="" className="w-20 mt-10 mx-auto invert" />
              </a>
            </li>
          ) : (
            <li className="h-45 w-45 pt-2 mr-2">
              <a className="" onClick={props.clickSearch}>
                <img src={searchIcon} alt="" className="w-20 mt-10 mx-auto" />
              </a>
            </li>
          )}
          {props.isHamburgerToggled ? (
            <li className="h-45 w-45 pt-2 mx-5 md:ml-5 md:mr-25 lg:mr-35">
              <a className="" onClick={props.clickHamburger}>
                <img src={xIcon} alt="" className="w-20 mt-10 m-auto" />
              </a>
            </li>
          ) : (
            <li className="h-45 w-45 pt-2 mx-5 md:ml-5 md:mr-25 lg:mr-35">
              <a className="" onClick={props.clickHamburger}>
                <img src={hamburgerIcon} alt="" className="w-20 mt-12 mx-auto" />
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default NavBar;
